export const MAGIC_ROW = 'magic_row';

export const getMagicRowLabel = () => 'For you';
